import axios from 'axios';
import { API_URL } from '../config/config.js';

// API基础配置 - 使用config.js配置
const API_BASE_URL = API_URL;

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000, // 增加到5分钟，适应音频处理
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加认证token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误和token刷新
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 如果是401错误且不是登录请求，尝试刷新token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          // 这里可以实现token刷新逻辑
          // const response = await apiClient.post('/auth/refresh', { refreshToken });
          // localStorage.setItem('accessToken', response.data.accessToken);
          // return apiClient(originalRequest);
        }
      } catch (refreshError) {
        // 刷新失败，清除token并跳转到登录页
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

// API响应数据格式化
const handleResponse = (response) => {
  const data = response.data;

  // 如果响应已经包含success字段，直接返回
  if (data && typeof data === 'object' && 'success' in data) {
    return data;
  }

  // 否则包装成标准格式
  return {
    success: true,
    data: data,
    message: '请求成功'
  };
};

const handleError = (error) => {
  const errorMessage = error.response?.data?.message || error.message || '请求失败';
  const errorCode = error.response?.status || 500;

  const errorObj = {
    message: errorMessage,
    code: errorCode,
    errors: error.response?.data?.errors || []
  };

  throw errorObj;
};

// 通用API方法
export const api = {
  get: async (url, config = {}) => {
    try {
      const response = await apiClient.get(url, config);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },

  post: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.post(url, data, config);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },

  put: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.put(url, data, config);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },

  delete: async (url, config = {}) => {
    try {
      const response = await apiClient.delete(url, config);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },

  patch: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.patch(url, data, config);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  }
};

export default apiClient;
